import { useFormContext, useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid2";
import React from "react";
import ValidatedCheckBoxElement from "./ValidatedCheckBoxElement";

interface IProps {
    label: string;
    name: string;
    readOnly: boolean;
    switchSize?: number;
    alwaysShow?: boolean;
}

export default function RenderCheckBoxField({ label, name, readOnly, switchSize = 12, alwaysShow = false }: IProps) {
    const { control, setValue } = useFormContext();
    let value = useWatch({ control, name });

    const booleanValue = value === "Y" ? true : value === "N" ? false : !!value;

    React.useEffect(() => {
        if (!readOnly) {
            if (value === "Y" || value === "N") {
                setValue(name, booleanValue);
            }
        }
    }, [value, name]);

    if (!alwaysShow && value == null) return null;

    return (
        <Grid container size={switchSize}>
            <Grid size={12}>
                <ValidatedCheckBoxElement name={name} value={booleanValue} label={label} disabled={readOnly} />
            </Grid>
        </Grid>
    );
}
